import { Add } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { Button } from "react-admin";

import { color, space, typography } from "../theme/designTokens";

type EmptyListProps = {
  image: string;
  description: string;
  createButton?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  };
};

export const EmptyList = ({ image, description, createButton }: EmptyListProps) => (
  <Box pt={space.xs}>
    <Box display="flex" justifyContent="flex-end">
      {createButton && (
        <Button
          label={createButton.label}
          variant="contained"
          onClick={createButton.onClick}
          disabled={createButton.disabled}
        >
          <Add />
        </Button>
      )}
    </Box>
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      pt={space.sm}
    >
      <Typography variant="body1" fontSize={typography.fontSize.lg} color={color.typographyBase}>
        {description}
      </Typography>
      <Box component="img" src={image} sx={{ width: "500px", maxWidth: "100%", height: "auto" }} />
    </Box>
  </Box>
);
